module.exports = __webpack_public_path__ + "media/images/realizacje/real19-f00b8f3745b2fe2e09472a520aa5aaa9.png";